// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__UL7DZ","paramInput":"JobSimulator_paramInput__1iuqd","input":"JobSimulator_input__1oxmT"};